import React from "react";
import "./HorizontalLoader.css";

const HorizontalLoader = () => {
  const bars = Array.from({ length: 3 }, (_, i) => i);

  return (
    <div className="horizontal-loader">
      {bars.map((i) => (
        <div
          key={i}
          className="horizontal-bar"
          style={{
            width: `${70 + (i % 2 === 0 ? 0 : -20)}%`, // Alternate long/short widths
            animationDelay: `${i * 0.2}s, ${i * 0.25}s`, // delay for shimmer AND lengthChange
          }}
        ></div>
      ))}
    </div>
  );
}

export default HorizontalLoader;
